import { render, staticRenderFns } from "./SpaceAndroid.vue?vue&type=template&id=1245d39d&scoped=true&"
import script from "./SpaceAndroid.vue?vue&type=script&lang=js&"
export * from "./SpaceAndroid.vue?vue&type=script&lang=js&"
import style0 from "./SpaceAndroid.vue?vue&type=style&index=0&id=1245d39d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1245d39d",
  null
  
)

export default component.exports